import { render, staticRenderFns } from "./IntegratedGender.vue?vue&type=template&id=e5fb179a&scoped=true&"
import script from "./IntegratedGender.vue?vue&type=script&lang=js&"
export * from "./IntegratedGender.vue?vue&type=script&lang=js&"
import style0 from "./IntegratedGender.vue?vue&type=style&index=0&id=e5fb179a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fb179a",
  null
  
)

export default component.exports